<template>
  <div v-if="brands.length > 1" class="bs">
    <label class="bs-label" :for="id">Brand</label>
    <span class="bs-dot" :style="{ background: all ? '#6B635B' : (current ? current.color : '#B4472B') }" aria-hidden="true"></span>
    <select :id="id" class="pb-select bs-select" :value="all ? 'all' : (current ? current.id : '')" @change="pick($event.target.value)">
      <option v-if="allowAll" value="all">All brands{{ totalNew ? ' · ' + totalNew + ' new' : '' }}</option>
      <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.name }}{{ newOf(brand) ? ' · ' + newOf(brand) + ' new' : '' }}</option>
    </select>
  </div>
</template>

<script>
let counter = 0;
// Each brand's new feedback is shown with its name, so the sidebar's "Inbox (N new)" total is easy to find. Where the
// page can show every brand at once (the inbox), "All brands" comes first and emits `all`.
export default {
  name: 'BrandSwitcher',
  props: {
    allowAll: { type: Boolean, default: false },
    all: { type: Boolean, default: false }
  },
  data() { counter += 1; return { id: 'brand-switch-' + counter }; },
  computed: {
    brands() { return this.$store.getters['praiseboard/activeBrands']; },
    current() { return this.$store.getters['praiseboard/brand']; },
    totalNew() { return this.brands.reduce((sum, brand) => sum + this.newOf(brand), 0); }
  },
  methods: {
    newOf(brand) { return (brand && brand.counts && brand.counts.new) || 0; },
    pick(value) {
      if (value === 'all') { this.$emit('all'); return; }
      this.$store.dispatch('praiseboard/selectBrand', Number(value));
      this.$emit('change', Number(value));
    }
  }
};
</script>

<style scoped>
.bs{display:inline-flex;align-items:center;gap:10px;position:relative}
.bs-label{font:600 13px/1 var(--font-body)!important;color:#4F4A45!important;margin:0!important}
.bs-dot{position:absolute;left:62px;top:50%;width:10px;height:10px;margin-top:-5px;border-radius:50%;pointer-events:none;z-index:1}
.bs-select{min-width:200px;max-width:280px;padding-left:28px;min-height:40px;padding-top:8px;padding-bottom:8px}
@media(max-width:600px){.bs{width:100%}.bs-select{flex:1;max-width:none;min-width:0}}
</style>
